import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HouseFlat } from '../../models/house-flat.model';
import { UtilService } from '../../services/util.service';
import { HouseFlatCodeService } from '../../services/house-flat-code.service';

@Component({
  selector: 'app-house-flat-code',
  templateUrl: './house-flat-code.component.html',
  styleUrl: './house-flat-code.component.scss'
})
export class HouseFlatCodeComponent {

  @Input() neighborhoodId: string = '';
  @Input() houseFlat?: HouseFlat;
  @Output() houseFlatChange = new EventEmitter<HouseFlat>();

  constructor(
    private houseFlatCodeService: HouseFlatCodeService,
    public utilService: UtilService,
  ) { }

  async newCode() {

    console.log(this.houseFlat);
    

    const flag = confirm(
      `¿Esta seguro que desea generar un nuevo código para la casa ${this.houseFlat?.number}?`
    );

    if(flag) {

      const houseFlatUpdated = await this.houseFlatCodeService.create(
        this.neighborhoodId,
        this.houseFlat!
      );

      if(houseFlatUpdated) {
        this.houseFlat!.code = houseFlatUpdated.code;
      }

    }

  }

}
